import {
  NAMESPACE_ONBOARDING,
  OnboardingConfigurationKeys,
  OnboardingConfigurations,
  OnboardingTarget,
} from '@epicuro-next/constants/rule-engine/onboarding-rules';
import {
  getValueFromConfigState,
  selectConfigurationsState,
  selectConfigurationValueFrom,
} from '@epicuro-next/platform/configuration';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { onboardingLabels } from '../contants';

import { onboardingFeatureKey, State } from './onboarding.reducer';

export const onboardingSelector =
  createFeatureSelector<State>(onboardingFeatureKey);

export const selectConsumerOnboarding = createSelector(
  onboardingSelector,
  (state) => state[OnboardingTarget.Consumer],
);

export const selectSalesRepOnboarding = createSelector(
  onboardingSelector,
  (state) => state[OnboardingTarget.SalesRep],
);

export const selectActiveTarget = createSelector(
  onboardingSelector,
  (state) => state.active,
);

export const selectActiveOnboarding = createSelector(
  onboardingSelector,
  (state) => (state.active ? state[state.active] : null),
);

export const selectOnboardingViewed = createSelector(
  onboardingSelector,
  (state) => state.viewed,
);

export const selectOnboardingEnabled = createSelector(
  onboardingSelector,
  (state) => state.enabled,
);

export const selectOnboardingSteps = createSelector(
  selectActiveOnboarding,
  selectActiveTarget,
  (activeOnboarding, activeTarget) => {
    if (activeOnboarding && activeTarget) {
      return activeOnboarding.map((item) => ({
        ...item,
        descriptionTranslationKey:
          onboardingLabels[activeTarget][item.descriptionTranslationKey],
        titleTranslationKey:
          onboardingLabels[activeTarget][item.titleTranslationKey],
        nextButtonTranslationKey:
          onboardingLabels[activeTarget][item.nextButtonTranslationKey],
      }));
    }
    return null;
  },
);

export const selectShowOnboardingPopupOnInit = createSelector(
  selectOnboardingEnabled,
  selectConfigurationsState,
  (enabled, config) => {
    if (!enabled) return false;

    return getValueFromConfigState<
      OnboardingConfigurationKeys.ShowOnboardingPopupOnInit,
      OnboardingConfigurations
    >(
      config,
      NAMESPACE_ONBOARDING,
      OnboardingConfigurationKeys.ShowOnboardingPopupOnInit,
      false,
    );
  },
);

export const selectShowConsumerOnboarding = createSelector(
  selectOnboardingEnabled,
  selectConfigurationsState,
  (enabled, config) => {
    if (!enabled) return false;

    return getValueFromConfigState<
      OnboardingConfigurationKeys.ShowConsumerOnboarding,
      OnboardingConfigurations
    >(
      config,
      NAMESPACE_ONBOARDING,
      OnboardingConfigurationKeys.ShowConsumerOnboarding,
      false,
    );
  },
);

export const selectShowSalesOnboarding = createSelector(
  selectOnboardingEnabled,
  selectConfigurationsState,
  (enabled, config) => {
    if (!enabled) return false;

    return getValueFromConfigState<
      OnboardingConfigurationKeys.ShowSalesOnboarding,
      OnboardingConfigurations
    >(
      config,
      NAMESPACE_ONBOARDING,
      OnboardingConfigurationKeys.ShowSalesOnboarding,
      false,
    );
  },
);

export const selectHideNeoclesLogo = createSelector(
  onboardingSelector,
  ({ hideNeoclesLogo }) => hideNeoclesLogo,
);

export const selectHideTenantLogo = createSelector(
  onboardingSelector,
  ({ hideTenantLogo }) => hideTenantLogo,
);

export const selectConsumerTutorialLink = selectConfigurationValueFrom<
  OnboardingConfigurationKeys.ConsumerTutorialLink,
  OnboardingConfigurations
>(NAMESPACE_ONBOARDING, OnboardingConfigurationKeys.ConsumerTutorialLink, '');

export const selectSalesTutorialLink = selectConfigurationValueFrom<
  OnboardingConfigurationKeys.SalesTutorialLink,
  OnboardingConfigurations
>(NAMESPACE_ONBOARDING, OnboardingConfigurationKeys.SalesTutorialLink, '');
